const MAP: Record<string, string> = { 'ي': 'ی', 'ى': 'ی', 'ك': 'ک', 'ة': 'ه' };

/**
 * Normalizes text by folding Arabic characters to Persian equivalents,
 * removing tatweel, harakat, superscript alef, and ZWNJ, and lowercasing.
 */
export function fold(s: string): string {
  return s
    .normalize('NFC')
    .replace(/[يىكة]/g, (c) => MAP[c])
    // eslint-disable-next-line no-misleading-character-class
    .replace(/[ـً-ٰٟ‌]/g, '') // tatweel, harakat, superscript alef, ZWNJ
    .toLowerCase();
}

export const toPersianLetters = (s: string): string => s.replace(/[يى]/g, 'ی').replace(/ك/g, 'ک');
export const toArabicLetters = (s: string): string => s.replace(/ی/g, 'ي').replace(/ک/g, 'ك');

/**
 * Normalized key used to deduplicate tab requests.
 * Uses folded text where non-alphanumeric sequences are collapsed to a single space.
 */
export function requestKey(artist: string, title: string): string {
  const norm = (s: string) => fold(s).replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  return `${norm(artist)}|${norm(title)}`;
}
